(() => {
  const normalizePath = (value) => {
    if (!value || value === "#" || value.startsWith("javascript:")) return "";

    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return "";
      const decodedPath = decodeURIComponent(url.pathname);
      return decodedPath.length > 1 ? decodedPath.replace(/\/+$/, "") : decodedPath;
    } catch (error) {
      return "";
    }
  };

  const directLink = (item) =>
    Array.from(item.children).find(
      (child) => child.matches && child.matches("a.m-menu__link")
    );

  const menuAncestors = (matchedLink) => {
    const ancestors = [];
    let item = matchedLink.closest("li");
    let parentItem = item && item.parentElement ? item.parentElement.closest("li") : null;

    while (parentItem) {
      const link = directLink(parentItem);
      if (link) ancestors.unshift(link);
      parentItem = parentItem.parentElement
        ? parentItem.parentElement.closest("li")
        : null;
    }

    return ancestors;
  };

  const breadcrumbCandidates = (breadcrumb) => {
    const candidates = [normalizePath(window.location.pathname)];
    const links = Array.from(
      breadcrumb.querySelectorAll(".m-breadcrumb--item[href]")
    ).reverse();

    links.forEach((link) => {
      const path = normalizePath(link.href);
      if (path && path !== "/" && !candidates.includes(path)) candidates.push(path);
    });

    return candidates;
  };

  const enhanceBreadcrumb = (breadcrumb) => {
    if (!breadcrumb || breadcrumb.dataset.menuEnhanced === "true") return;

    const menuLinks = Array.from(
      document.querySelectorAll(
        ".m-header__desktop .m-header__menu > .m-menu a.m-menu__link[href]"
      )
    );
    if (!menuLinks.length) return;

    let matchedLink = null;
    let matchedPath = "";

    for (const candidate of breadcrumbCandidates(breadcrumb)) {
      matchedLink = menuLinks.find(
        (link) => normalizePath(link.getAttribute("href")) === candidate
      );
      if (matchedLink) {
        matchedPath = candidate;
        break;
      }
    }

    if (!matchedLink) {
      breadcrumb.dataset.menuEnhanced = "true";
      return;
    }

    const ancestors = menuAncestors(matchedLink);
    if (!ancestors.length) {
      breadcrumb.dataset.menuEnhanced = "true";
      return;
    }

    const items = Array.from(breadcrumb.querySelectorAll(".m-breadcrumb--item"));
    let targetItem = items.find(
      (item) =>
        item.matches("a[href]") &&
        normalizePath(item.getAttribute("href")) === matchedPath
    );

    if (!targetItem && matchedPath === normalizePath(window.location.pathname)) {
      targetItem = breadcrumb.querySelector(".m-breadcrumb--item-current");
    }
    if (!targetItem) return;

    const separatorTemplate = breadcrumb.querySelector(
      ".m-breadcrumb--separator"
    );
    if (!separatorTemplate) return;

    const existingItems = Array.from(
      breadcrumb.querySelectorAll(".m-breadcrumb--item")
    );
    const fragment = document.createDocumentFragment();

    ancestors.forEach((ancestor) => {
      const title = ancestor.textContent.trim();
      const path = normalizePath(ancestor.getAttribute("href"));
      const alreadyExists = existingItems.some((item) => {
        const itemPath = item.matches("a[href]")
          ? normalizePath(item.getAttribute("href"))
          : "";
        return (path && itemPath === path) || item.textContent.trim() === title;
      });

      if (alreadyExists) return;

      let breadcrumbItem;
      if (path) {
        breadcrumbItem = document.createElement("a");
        breadcrumbItem.href = ancestor.href;
      } else {
        breadcrumbItem = document.createElement("span");
      }
      breadcrumbItem.className = "m-breadcrumb--item";
      breadcrumbItem.textContent = title;

      fragment.append(breadcrumbItem);
      fragment.append(separatorTemplate.cloneNode(true));
    });

    targetItem.parentNode.insertBefore(fragment, targetItem);
    breadcrumb.dataset.menuEnhanced = "true";
  };

  const init = (scope = document) => {
    scope
      .querySelectorAll("[data-menu-breadcrumb]")
      .forEach(enhanceBreadcrumb);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", () => init());
})();

